import { useEffect, useState } from 'react';
import { formatClock } from '../duration.js';

/**
 * How long is left to program.
 *
 * The deadline is a fixed instant from the server, so this ticks locally
 * rather than polling: one request per second per player, to count down a
 * number, would be absurd.
 *
 * Shows nothing when there is no deadline, which is also what an untimed
 * game looks like -- the host may switch the timer off entirely, and turn
 * 1 is never timed whatever they set.
 *
 * A PAUSED game also carries no deadline, which is how the server's sweep
 * leaves it alone. That is the one case where saying nothing would be
 * wrong: the players want to know the clock is stopped rather than that
 * it was never running.
 */
export function Countdown(
  { deadline, paused }: { deadline: string | null; paused?: boolean },
) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!deadline) return undefined;
    const tick = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(tick);
  }, [deadline]);

  if (paused) return <p className="countdown mono">Clock stopped by the host</p>;
  if (!deadline) return null;

  const endsAt = new Date(deadline).getTime();
  if (Number.isNaN(endsAt)) return null;

  const left = Math.max(0, Math.round((endsAt - now) / 1000));

  return (
    <p className={`countdown mono${left <= 15 ? ' urgent' : ''}`}>
      {left === 0
        ? 'Time is up'
        : `${formatClock(left)} left to program`}
    </p>
  );
}
